var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"missions"},[_c('ctk-side-bar',{ref:"searchSideBar",staticClass:"missions-menu tw-flex tw-flex-col",attrs:{"width":350,"open":_vm.isSidebarOpen},on:{"toggle-menu":_vm.toggleSidebar}},[_c('mission-sections',{staticStyle:{"padding-bottom":"100px"}})],1),_c('RouterView',{staticClass:"main-container",class:{
      'has-menu-sidebar': _vm.isSidebarOpen,
    }})],1)}
var staticRenderFns = []

export { render, staticRenderFns }